import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "navbar"
  }, [_c("hamburger", {
    staticClass: "hamburger-container",
    attrs: {
      "is-active": _vm.sidebar.opened
    },
    on: {
      toggleClick: _vm.toggleSideBar
    }
  }), !_vm.topNav ? _c("breadcrumb", {
    staticClass: "breadcrumb-container"
  }) : _vm._e(), _vm.topNav ? _c("top-nav", {
    staticClass: "topmenu-container",
    attrs: {
      id: "topmenu-container"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "right-menu"
  }, [_vm.device !== "mobile" ? [_c("search", {
    staticClass: "right-menu-item",
    attrs: {
      id: "header-search"
    }
  }), _c("Screenfull", {
    staticClass: "right-menu-item hover-effect"
  }), _vm.showAiChat ? _c("el-tooltip", {
    attrs: {
      content: "AI 数据助手",
      placement: "bottom"
    }
  }, [_c("div", {
    staticClass: "right-menu-item hover-effect ai-chat-btn",
    on: {
      click: function click($event) {
        _vm.aiChatVisible = true;
      }
    }
  }, [_c("span", {
    staticClass: "ai-badge"
  }, [_c("i", {
    staticClass: "el-icon-magic-stick"
  }), _c("span", [_vm._v("AI")])])])]) : _vm._e(), _vm.showImChat ? _c("el-tooltip", {
    attrs: {
      content: "消息",
      placement: "bottom"
    }
  }, [_c("div", {
    staticClass: "right-menu-item hover-effect im-chat-btn",
    on: {
      click: function click($event) {
        _vm.imChatVisible = true;
      }
    }
  }, [_c("el-badge", {
    attrs: {
      value: _vm.imUnreadCount,
      hidden: !_vm.imUnreadCount,
      max: 99
    }
  }, [_c("i", {
    staticClass: "el-icon-chat-dot-round",
    staticStyle: {
      "font-size": "20px"
    }
  })])], 1)]) : _vm._e()] : _vm._e(), _c("el-dropdown", {
    staticClass: "avatar-container right-menu-item hover-effect",
    attrs: {
      trigger: "click"
    }
  }, [_c("div", {
    staticClass: "avatar-wrapper"
  }, [_c("img", {
    staticClass: "user-avatar",
    attrs: {
      src: _vm.avatar && _vm.avatar !== "" ? _vm.avatar : "/images/default-avatar.svg"
    }
  }), _c("span", {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.name))]), _c("i", {
    staticClass: "el-icon-caret-bottom"
  })]), _c("el-dropdown-menu", {
    staticClass: "user-dropdown",
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("router-link", {
    attrs: {
      to: "/"
    }
  }, [_c("el-dropdown-item", [_vm._v("首页")])], 1), _c("el-dropdown-item", [_c("span", {
    staticStyle: {
      display: "block"
    },
    on: {
      click: _vm.openAppDownloadPage
    }
  }, [_vm._v("App 下载")])]), _c("el-dropdown-item", [_c("span", {
    staticStyle: {
      display: "block"
    },
    on: {
      click: function click($event) {
        return _vm.$refs.changePassword.handleShow();
      }
    }
  }, [_vm._v("修改密码")])]), _c("el-dropdown-item", {
    attrs: {
      divided: ""
    }
  }, [_c("span", {
    staticStyle: {
      display: "block"
    },
    on: {
      click: function click($event) {
        _vm.uiPreferenceVisible = true;
      }
    }
  }, [_vm._v("界面偏好")])]), _c("el-dropdown-item", {
    attrs: {
      divided: ""
    }
  }, [_c("span", {
    staticStyle: {
      display: "block"
    },
    on: {
      click: _vm.logout
    }
  }, [_vm._v("注销")])])], 1)], 1)], 2), _c("changePassword", {
    ref: "changePassword"
  }), _c("el-dialog", {
    attrs: {
      title: "界面偏好",
      visible: _vm.uiPreferenceVisible,
      width: "420px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.uiPreferenceVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "ui-preference-item"
  }, [_c("div", {
    staticClass: "ui-preference-copy"
  }, [_c("div", {
    staticClass: "ui-preference-title"
  }, [_vm._v("高级查询浮层")]), _c("div", {
    staticClass: "ui-preference-desc"
  }, [_vm._v("展开更多查询时浮在表格上方，查询后自动收起。")])]), _c("el-switch", {
    model: {
      value: _vm.filterOverlay,
      callback: function callback($$v) {
        _vm.filterOverlay = $$v;
      },
      expression: "filterOverlay"
    }
  })], 1)]), _vm.showAiChat ? _c("ai-chat", {
    attrs: {
      visible: _vm.aiChatVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.aiChatVisible = $event;
      }
    }
  }) : _vm._e(), _vm.showImChat ? _c("im-chat", {
    attrs: {
      visible: _vm.imChatVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.imChatVisible = $event;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };